module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-3"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-3-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-3-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("Belfast, Northern Ireland")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("January 2014")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("t was a pattern he had imperceptibly drifted into.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sitting up alone into the early hours.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Able to do so thanks to the power naps he took in the afternoons in Interview Room C. Left well alone by the junior officers who had noted his routine. If Detective Inspector Dan Watson missed his snooze for some reason, they agreed he was like a zombie with a grudge.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Channel-hopping at 1.30am with the sound down low.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Settling momentarily on "), _c('i', [_vm._v("Family Guy")]), _vm._v(", "), _c('i', [_vm._v("Come Dine With Me ")]), _vm._v("or "), _c('i', [_vm._v("Amsterdam Nights")]), _vm._v(", before flicking on. On to God knows what.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fingering the ice cubes into the tumbler to prevent the telltale clinking in these silent early hours.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Splashing the Bushmills liberally from his hidden cache. The good stuff.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The bottle ‘for guests’ still virgin and pristine in the drinks cabinet.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Then up at 5.30am again as usual. Shave… shit… shower.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Making the effort not to wake Elaine, although both were now used to the futility of this.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Exaggerated sighs of annoyance and duvet-shifting. A practised choreography of gestures.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The small of his back ached.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Had done for months now. Not exactly muscular.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("At fifty-one years of age, it could simply be his sedentary lifestyle.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Or it could be something much more sinister.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("His last routine check-up from Dr Bryant the police GP revealed type 2 diabetes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He was not alone.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A minor epidemic amongst unfit coppers with fat-roll waistlines and takeaway lifestyles had solicited an avalanche of preventive, self-help pamphlets from Human Resources.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Wankers! More concerned about sick leave than officer welfare")]), _vm._v(", he thought. "), _c('i', [_vm._v("Wire-necked pen-pushing middle-management wankers! Creating a little empire for themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Now he had to attend a diabetes clinic where the nurse asked him to close his eyes and say when he could feel a pinprick on his toes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The toes were the most vulnerable apparently. Then the feet themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And perhaps ultimately the leg. Christ!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Still, he knew that tomorrow he would still have his fried bacon and egg soda farl as usual.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And his massage.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("His full body massage. All above board.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No happy endings here.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He’d been going to Nicola, his regular massage therapist at the Sports Injury Clinic, for years now. He suspected she was a dyke but nevertheless prided himself on his ability to avoid an erection when she brushed against his inner thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mind over matter.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Even when his back wasn’t bothering him, he never missed a session.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He realised that – even if it wasn’t sexual – it was the only intimate touching, the only human contact from a woman that he’d had in a very long time.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It depressed the hell out of him so he chose not to think about it in those terms.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A gust of winter gale whistled down the chimney and into the dark, empty fireplace.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The curtains moved a little.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The central heating had long since clicked off.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("On TV, two Dutch cops were arresting a punter who refused to pay.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The hooker complained – in subtitles – that his inability to get a hard-on wasn’t her fault.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He drained the glass and wondered – was it time?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The tentative climb.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The creaking stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The spare room.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01ab01ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-003.vue
// module id = 84
// module chunks = 0